import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    editRatingGroup: [],
    loading: false,
    error: null,
}

const editRatingGroupSlice = createSlice({
    name: "editRatingGroup",
    initialState,
    reducers: {
        fetcheditRatingGroupSuccess: (state, action) => {
            state.loading = false,
            state.editRatingGroup = action.payload;
        },
        fetcheditRatingGroupFailure: (state, action) => {
            state.loading = false,
            state.error = action.payload;
        },
    },
})

export const {
    fetcheditRatingGroupSuccess,
    fetcheditRatingGroupFailure,
} = editRatingGroupSlice.actions;

export default editRatingGroupSlice.reducer;